import { BezierCurve } from '../bezier/bezier';

export const defaultLoadCurve: BezierCurve = [
  { x: 6, y: 60, cp1x: 4, cp1y: 60, cp2x: 8, cp2y: 60 },   // 6AM - low load (60 MW)
  { x: 12, y: 120, cp1x: 10, cp1y: 120, cp2x: 14, cp2y: 120 }, // 12PM - high load (120 MW)
  { x: 18, y: 150, cp1x: 16, cp1y: 150, cp2x: 20, cp2y: 150 }, // 6PM - peak load (150 MW)
  { x: 24, y: 80, cp1x: 22, cp1y: 80, cp2x: 26, cp2y: 80 }, // 12AM - medium load (80 MW)
];

export const flatLoadCurve: BezierCurve = [
  { x: 6, y: 100, cp1x: 4, cp1y: 100, cp2x: 8, cp2y: 100 },   // 6AM - constant load (100 MW)
  { x: 12, y: 100, cp1x: 10, cp1y: 100, cp2x: 14, cp2y: 100 }, // 12PM - constant load (100 MW)
  { x: 18, y: 100, cp1x: 16, cp1y: 100, cp2x: 20, cp2y: 100 }, // 6PM - constant load (100 MW)
  { x: 24, y: 100, cp1x: 22, cp1y: 100, cp2x: 26, cp2y: 100 }, // 12AM - constant load (100 MW)
];

export const industrialLoadCurve: BezierCurve = [
  { x: 6, y: 140, cp1x: 4, cp1y: 140, cp2x: 8, cp2y: 140 },   // 6AM - industrial start (140 MW)
  { x: 12, y: 190, cp1x: 10, cp1y: 190, cp2x: 14, cp2y: 190 }, // 12PM - peak industrial (190 MW)
  { x: 18, y: 170, cp1x: 16, cp1y: 170, cp2x: 20, cp2y: 170 }, // 6PM - industrial wind down (170 MW)
  { x: 24, y: 40, cp1x: 22, cp1y: 40, cp2x: 26, cp2y: 40 }, // 12AM - minimal overnight (40 MW)
];

// Default wind curve - typically stronger at night and early morning
export const defaultWindCurve: BezierCurve = [
  { x: 6, y: 70, cp1x: 4, cp1y: 75, cp2x: 8, cp2y: 65 },   // 6AM - morning wind (70%)
  { x: 12, y: 40, cp1x: 10, cp1y: 50, cp2x: 14, cp2y: 30 }, // 12PM - midday calm (40%)
  { x: 18, y: 50, cp1x: 16, cp1y: 45, cp2x: 20, cp2y: 55 }, // 6PM - evening breeze (50%)
  { x: 24, y: 80, cp1x: 22, cp1y: 65, cp2x: 26, cp2y: 85 }, // 12AM - strong night wind (80%)
];

// Default solar curve - follows daylight hours
export const defaultSolarCurve: BezierCurve = [
  { x: 6, y: 5, cp1x: 4, cp1y: 0, cp2x: 8, cp2y: 20 },     // 6AM - sunrise (5%)
  { x: 12, y: 90, cp1x: 10, cp1y: 75, cp2x: 14, cp2y: 75 }, // 12PM - solar peak (90%)
  { x: 18, y: 5, cp1x: 16, cp1y: 20, cp2x: 20, cp2y: 0 },   // 6PM - sunset (5%)
  { x: 24, y: 0, cp1x: 22, cp1y: 0, cp2x: 26, cp2y: 0 },    // 12AM - no solar (0%)
];